import AssetConfig from '@/models/AssetConfig'
import Paginator from '@/models/Paginator'
import { asset as backend } from '@/api'
import { common as pathLoader } from '@/api'

export default {

  namespaced: true,

  state: {
    config: new AssetConfig,
    configs: new Paginator,
    config_list: [],
  },

  mutations: {
    clear: (state) => state.config = new AssetConfig,
    name: (state, payload) => state.config.name = payload,
    description: (state, payload) => state.config.description = payload,
    addParam: (state, payload) => {
      state.config.data.push(payload)
    },
    removeParam: (state, payload) => {
      let index = state.config.data.indexOf(payload)

      state.config.data.splice(index, 1)
    },
    setConfigs: (state, payload) => state.configs = payload,
    setConfig: (state, payload) => state.config = payload,
    setConfigList: (state, payload) => state.config_list = payload,
    addConfig: (state, payload) => state.configs.data.push(payload),
    toggleParamReadonly: (state, payload) => {
      let index = state.config.data.indexOf(payload)

      let param = state.config.data[index]
      param.readonly = !param.readonly

      state.config.data.splice(index, 1, param)
    },
  },

  actions: {
    store: ({state}) => new Promise((resolve, reject) => {
      backend.storeConfig(
        state.config, 
        ({data}) => resolve(data),
        error => reject(error)
      )
    }),
    save: ({state}) => new Promise((resolve, reject) => {
      backend.updateConfig(
        state.config, 
        ({data}) => resolve(data),
        error => reject(error)
      )
    }),
    loadConfigs: ({commit}, payload) => new Promise((resolve, reject) => {
      pathLoader.loadPath(payload, ({data}) => {
        commit('setConfigs', data)
        resolve(data)
      }, error => reject(error))
    }),
    loadConfigList: ({commit}) => new Promise((resolve, reject) => {
      backend.loadConfigList(({data}) => {
        commit('setConfigList', data)
        resolve(data)
      }, error => reject(error))
    })
  },

  getters: {
    config: state => state.config,
    configs: state => state.configs,
    config_list: state => state.config_list,
  }
}